module.exports = {
      id: "double-arrow-usage",
      viewBox: "0 0 21.133 19.508",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#double-arrow",
      toString: function () {
        return this.url;
      }
    }